(function (ws) {
    'use strict';
    ws.models.ManualrmaSerialNumbersModel = Backbone.Model.extend({
        defaults: {
            serialNumber: '',
            selected: false
        }
    });
})(westcon);
